// extracted by mini-css-extract-plugin
export default {"SolutionPage":"FeaturePage-module--SolutionPage--2AnNg"};